import { formatCpDate } from '@cp-shared-15/common-utilities';
import { isFirstRegistrationLocalStorageKey } from '../../../config/config';

export const isUserDetailsHookPage = (lastLogin: string, lastContactDetailsHookPage: string): boolean => {
    const today = formatCpDate();

    if (today.diff(lastLogin, 'M', false) >= 3) {
        return true;
    } else if (today.diff(lastContactDetailsHookPage, 'M', false) >= 6 || lastContactDetailsHookPage === '') {
        return true;
    }

    return false;
};

export const isIntroductionHookPage = (): boolean => !!window.localStorage.getItem(isFirstRegistrationLocalStorageKey);
